import { useState } from 'react';
import LeftCard from '../Layout/Left-side-card/Left-side-card';
import RightCard from '../Layout/Right-side-card/Right-side-card';
import TitleBar from '../Layout/TitleBar/TitleBar';
import TitleBarMobile from '../Layout/TitleBar/TitleBarMobile';
import BottomNavBar from '../Layout/TitleBar/NavBar/BottomNavBar';
import './Home.css'
import { useWebSocket } from '../hooks/Websocket';

const Home = () => {
    const ws = useWebSocket()
    const [rightComponent, setRightComponent] = useState(
        {
            component: {
                name: "explore",
                friendName: "",
            }
        }
    );

    const handleComponentSwitch = (name, friendName) => {
        setRightComponent({
            component: {
                name: name,
                friendName: friendName,
                isFriend: true
            }
        });
    }

    ws.RegisterCallback("explore-chat", (friendName, isFriend) => {
        setRightComponent({
            component: {
                name: "chat",
                friendName:  friendName,
                isFriend: isFriend
            }
        })
    })

    const isMobile = window.innerWidth < 1400
    const titleBar = isMobile 
        ? <TitleBarMobile/> 
        : <TitleBar onSwitch={handleComponentSwitch}/>

    return(
        <div className='home'>
            {titleBar}
            <div className='home-body'>
                {!isMobile && <LeftCard onSwitch={handleComponentSwitch}/>}
                <RightCard component={rightComponent} onSwitch={handleComponentSwitch}/>
            </div>
            {isMobile && <BottomNavBar onSwitch={handleComponentSwitch}/>}
        </div>
    );
}

export default Home;